import { HomeTaskSubscriptionDao } from '@rock/db-admin';
import type { ConsiderationTypeId, HomeId, HomeTaskSubscriptionId } from '@rock/types';
import { shallowEqual } from '@rock/util';
import { atomFamily } from 'jotai/utils';

const homeTaskSubscriptionDao = new HomeTaskSubscriptionDao();

export const homeTaskSubscriptionsForConsiderationTypeState = atomFamily(
    (considerationTypeId: ConsiderationTypeId | undefined) =>
        homeTaskSubscriptionDao.taskSubscriptionsForConsiderationTypeAtom(considerationTypeId),
    shallowEqual,
);

export const homeTaskSubscriptionsForHomeAndConsiderationTypeState = atomFamily(
    (params: { homeId: HomeId | undefined; considerationTypeId: ConsiderationTypeId | undefined }) =>
        homeTaskSubscriptionDao.taskSubscriptionsForHomeAndConsiderationTypeAtom(
            params.homeId,
            params.considerationTypeId,
        ),
    shallowEqual,
);

export const homeTaskSubscriptionsListState = atomFamily(
    (homeId: HomeId | null) => homeTaskSubscriptionDao.taskSubscriptionsListAtom(homeId),
    shallowEqual,
);

export const homeTaskSubscriptionState = atomFamily(
    (params: { homeId: HomeId | undefined; subscriptionId: HomeTaskSubscriptionId | undefined }) =>
        homeTaskSubscriptionDao.taskSubscriptionAtom(params.homeId, params.subscriptionId!),
    shallowEqual,
);
